import React from 'react'
import { get } from 'lodash';
import { numberFormat as NumberFormat } from './numberFormat';

/**
 * @param {postcode} //object //receives lender type i.e 1 or 2 & receives lender lvrRatio info and its category
 */


const LenderInfo = ({ postcode }) => {
    const { lender: lenderType, value: postcodeInfo } = { ...postcode }

    const lvr =[
        "80% LVR","90% LVR", "95% LVR"
    ]
    return (
        <div className="ResultSection result-section">
            <div className='result-card'>
                <div className="result-card__header d-flex justify-content-between ">
                    <div className="result-card__header--title">Lender {lenderType}</div>
                
                </div>
                <div className='result-card__list'>
                    <div className=" result-card__list--label result--lg text-bold">Loan to Value Ratio (LVR) </div>
                    <div class="text-right"><span class="result--lg text-bold"><span data-testid="result">Max. Loan Amount</span></span></div>
                </div>
                {get(postcodeInfo, 'maxLoanAmount') &&
                                        // value => loan amount acc to lvr percentage 
                                        Object.entries(get(postcodeInfo, 'maxLoanAmount')).map(([key, value], index) => {
                                            return( <div key={index} className='result-card__list'>
                                            <div className=' result-card__list--label result--lg'> {lvr[index]}</div>
                                            <div  className="text-right">
                                                <div className={`inner-list-right-td
                                                     ${Object.keys(postcodeInfo.maxLoanAmount).length - 1 === index ? 'last-inner-td' : ' '}`} ><span>
                                                        <NumberFormat value={value} name={`${key}${lenderType}`} /></span></div>
                                            </div>
                                            
                                            </div>)
                                        })}

<div className='result-card__list result-card__list--cat'>
                    <div className=" result-card__list--label result--lg text-bold">Category  </div>
                    <div class="text-right"><span class="result--lg text-bold">{get(postcodeInfo, 'category')}</span></div>
                </div>
                       
                </div>            
            
        </div >
    )
}

export default LenderInfo
